// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Wbm0o","footer":"Form_footer__1gp_p"};